module.exports = __webpack_public_path__ + "static/img/SAD-4.c0e6067.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SAD-4.jpg
// module id = qxOC
// module chunks = 0